// extracted by mini-css-extract-plugin
export var featuredPost = "index-module--featured-post--913fa";
export var featuredPostContent = "index-module--featured-post-content--4d51d";
export var featuredPostSummary = "index-module--featured-post-summary--3c1dc";
export var featuredPostThumbnail = "index-module--featured-post-thumbnail--dcb21";
export var featuredPostTitle = "index-module--featured-post-title--ced2b";
export var hero = "index-module--hero--7f78c";
export var moreLink = "index-module--moreLink--91a07";
export var section = "index-module--section--5ee53";
export var title = "index-module--title--b96c1";